import React from 'react';
import { PropTypes } from '~/utils';
import { InfoBlock } from '~/components';

export function InfoPage( props ) {
  return ( <InfoBlock id={props.id} /> );
}
InfoPage.propTypes = {
  id : PropTypes.string.isRequired,
};
